var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKorea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "-72 -48 144 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-72-48v96H72v-96z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(33.69006752598)",
    d: "M-50-12v24m6 0v-24m6 0v24m76 0V1m0-2v-11m6 0v11m0 2v11m6 0V1m0-2v-11"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-33.69006752598)",
    d: "M-50-12v24m6 0V1m0-2v-11m6 0v24m76 0V1m0-2v-11m6 0v24m6 0V1m0-2v-11"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(33.69006752598)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M12 0a18 18 0 11-36 0 24 24 0 1148 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0 0a12 12 0 1124 0 24 24 0 11-48 0 12 12 0 1024 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorea);
export default __webpack_public_path__ + "static/media/korea.d432e7804da14495fb34497ebd0c8b4d.svg";
export { ForwardRef as ReactComponent };